import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import {
  FormHeader, Desc,
} from '../common/styles';
import SignUpForm from './sign-up-form';
import LinkedInButton from '../common/linkedin-button';
import GoogleButton from '../common/google-button';
import Separator from '../common/separator';

const Gradient = styled.div`
  background-image: ${props => props.theme.linearGradientDarkThemeRect};
  width: 100%;
  padding: 20px 15px;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  ${props => (props.theme.isMobile ? `
    padding: 35px 15px 15px 15px;
    border-radius: 4px;
    border: 1px solid ${props.theme.secondaryColor30Transparent};
    justify-content: flex-start;
  ` : `
    justify-content: center;
    min-height: 680px;
    padding: 40px;
  `)}
  ${props => props.theme.isXLarge && `
    width: 33vw;
    padding-left: 25px;
  `}
`;

const SDesc = styled(Desc)`
  margin: 10px 0 20px 0;
`;

const Terms = styled(Desc)`
  margin-top: 16px;
  max-width: 320px;
  font-size: 13px;
  line-height: 16px;

  & > a {
    color: ${props => props.theme.secondaryColor};
  }
`;

const PromptToSignIn = styled(Desc)`
  margin-top: ${props => (props.theme.isMobile ? 10 : 30)}px;
  max-width: 320px;
  font-size: 14px;
  line-height: 15px;
  font-weight: ${props => props.theme.fontWeightHeavy};

  & > a {
    color: ${props => props.theme.primaryColor};
  }
`;

const Pane = () => (
  <React.Fragment>
    <FormHeader>It’s free to join Livewire</FormHeader>
    <SDesc>
      {
        'Complete the registration form below to get unlimited access to '
        + 'Livewire’s investment insights and analysis.'
      }
    </SDesc>
    { !!window.Livewire.features.LoginWithGoogle && <GoogleButton eventType="sign_up" /> }
    <LinkedInButton />
    <Separator text="or" />
    <SignUpForm />
    <Terms>
      {'By clicking Join Free you agree to Livewire’s '}
      <a href="/company/terms_and_conditions">Terms and Conditions</a>
      {' and '}
      <a href="/company/privacy">Privacy Disclaimer</a>
    </Terms>
    <PromptToSignIn>
      {'Already have a Livewire account? '}
      <a href="/sign_in">Sign In</a>
    </PromptToSignIn>
  </React.Fragment>
);

export default function SignUpPane() {
  const { isMobile } = React.useContext(ThemeContext);

  return isMobile ? (
    <Gradient>
      <Container>
        <Pane />
      </Container>
    </Gradient>
  ) : (
    <Container>
      <Pane />
    </Container>
  );
}
